import { MouseEventHandler } from "react"
import LocationProps from "../../props/LocationProps"

type LocationsProps = {
  locations: LocationProps[],
  userLatLng: google.maps.LatLngLiteral | null,
  sortOrder: string,
  setUserShowModal: (flag: boolean) => void,
  setActiveLocation: (flag: LocationProps[]) => void
}
type LocTypeStringProps = {
  [key: string]: string
}
const Locations = ({
  locations,
  userLatLng,
  setUserShowModal,
  setActiveLocation,
}:LocationsProps) => {

  const handleClick:MouseEventHandler = evt => {
    evt?.preventDefault()
    const target = evt.target as HTMLElement

    if (!target) return

    const locString = target.dataset.loc

    if (!locString || locString.length < 1) return
    const loc = JSON.parse(locString)
    setUserShowModal(true)
    setActiveLocation([loc])
    return false
  }

  const locTypeStr:LocTypeStringProps = {
    crc: 'Community Recycling Centre',
    cre: 'Chemical Cleanout Event'
  }

  return (
    <>
      <div className="nsw-in-page-alert nsw-in-page-alert--info nsw-m-bottom-lg">
        <span className="material-icons nsw-material-icons nsw-in-page-alert__icon" aria-hidden="true">info</span>
        <div className="nsw-in-page-alert__content">
          <p className="nsw-h5">How distance is calculated</p>
          <p>When searching by a postcode or suburb,  distance is calculated from the centre of the suburb. Otherwise, the distance is calculated from the address entered.</p>
        </div>
      </div>
      {locations.map(loc => {
        return (
          <>
            {loc.active &&
              <div className="nsw-list-item">
                <div className="nsw-list-item__content crc-list-item">
                  <div className="nsw-list-item__label">{locTypeStr[loc?.type]}</div>
                  <div className="nsw-list-item__label crc-list-item__distance">
                    &nbsp;
                    {userLatLng && <>{loc.distance?.toFixed(2)}km</>}
                  </div>
                  <div className="nsw-list-item__title"><a href="#" data-loc={JSON.stringify(loc)} onClick={handleClick}>{loc.title}</a></div>
                  {loc.dates?.length &&
                    <div className="nsw-list-item__info nsw-display-flex">
                      <strong>Dates:</strong>
                      <div className="nsw-m-left-sm">

                      {loc.dates.map(locdate => {
                        return (
                          <div className="crc-dates">
                            {locdate.start &&
                              <span>
                                {
                                  new Date(locdate.start).toDateString()
                                }
                              </span>
                            }
                            {locdate.end && locdate.start !== locdate.end &&
                              <>
                                &mdash;
                                <span>
                                  {
                                    new Date(locdate.end).toDateString()
                                  }
                                </span>
                              </>
                            }
                          </div>
                        )
                      })}
                      </div>
                    </div>
                  }
                  {loc?.description &&
                    <div className="nsw-list-item__copy" dangerouslySetInnerHTML={{__html: loc?.description}} />
                  }
                </div>
              </div>
            }
          </>
        )
      }
    )}
  </>
)}


export default Locations
